import React from 'react'
import { Helmet } from 'react-helmet-async'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'
import api from '../../api'
import Responsive from '../../assets/config/Responsive'
import Colors from '../../assets/styles/Colors'
import { Container } from '../../assets/styles/GlobalStyle'
import Loader from '../../components/Loader'
import ScreenHeader from '../../components/ScreenHeader'
import ServiceCard from '../../components/ServiceCard'
import { useAppSelector } from '../../store'
import { AppState } from '../../store/appSlice'
import { useNavigate } from 'react-router-dom'

const Category = () => {
  const navigate = useNavigate()
  const { t } = useTranslation()

  const { lang } = useAppSelector((root: { app: AppState }) => root.app)
  const { data: productCategory, isLoading: isProductCategoryLoading } = api.useGetProductCategoryQuery(undefined)

  return isProductCategoryLoading ? (
    <Loader />
  ) : (
    <>
      {/* FOR SEO */}
      <Helmet>
        <title>{t('categorySeoTitle')}</title>
        <meta name="description" content={`${t('categorySeoDescription')}`} />
        <link rel="canonical" href={window.location.href} />
      </Helmet>

      {/* FOR SEO */}
      <ScreenHeader text={t('homePage')} url="/" />
      <Wrapper>
        <Container>
          <InfoBlock>
            {/* page tittle */}
            <InfoTittle>{t('categoryTitle') as string}</InfoTittle>
            {/* page tittle */}
            <CardWrapper>
              {productCategory &&
                productCategory.map((item, index) => {
                  //
                  const soonText = t('productWillBeAdded')
                  //
                  return (
                    <ServiceCard
                      key={index}
                      to={item.type === 'travel' ? `/single-select-date` : `/${item.type}/product-detail`}
                      onClick={() => {
                        if (item.type === 'travel') {
                          navigate('/single-select-date')
                        } else {
                          navigate(`/${item.type}/product-detail`)
                        }
                      }}
                      disabled={
                        item.type === 'travel'
                          ? false
                          : item.type === 'tpl'
                          ? false
                          : item.type === 'international-tpl'
                          ? false
                          : item.type === 'welcomer'
                          ? false
                          : item.type === 'pet'
                          ? false
                          : item.type === 'health'
                          ? false
                          : item.type === 'critical'
                          ? false
                          : item.type === 'casco'
                          ? false
                          : item.type === 'property'
                          ? false
                          : true
                      }
                      hideMinPrice={true}
                      img={item.image}
                      itemTitle={item?.translations?.[lang]?.title || ''}
                      itemBody={item?.translations?.[lang]?.body || ''}
                      itemType={`/${item.type}`}
                      bottomText={
                        item.type === 'travel'
                          ? ''
                          : item.type === 'tpl'
                          ? ''
                          : item.type === 'international-tpl'
                          ? ''
                          : item.type === 'welcomer'
                          ? ''
                          : item.type === 'pet'
                          ? ''
                          : item.type === 'health'
                          ? t('showProductDetails')
                          : item.type === 'critical'
                          ? t('showProductDetails')
                          : item.type === 'casco'
                          ? t('showProductDetails')
                          : item.type === 'property'
                          ? t('showProductDetails')
                          : soonText
                      }
                      arrow={
                        item.type === 'travel'
                          ? true
                          : item.type === 'tpl'
                          ? true
                          : item.type === 'international-tpl'
                          ? true
                          : item.type === 'welcomer'
                          ? true
                          : item.type === 'pet'
                          ? true
                          : item.type === 'health'
                          ? true
                          : item.type === 'critical'
                          ? true
                          : item.type === 'casco'
                          ? true
                          : item.type === 'property'
                          ? true
                          : false
                      }
                    />
                  )
                })}
            </CardWrapper>
          </InfoBlock>
        </Container>
      </Wrapper>
    </>
  )
}

// styles davit julakidze
const Wrapper = styled.div`
  background-color: ${Colors.backgroundGrey};
  padding-bottom: 130px;
  padding-top: 60px;
  min-height: calc(100vh - 88px);
  ${Responsive.mobile} {
    padding-bottom: 60px;
    padding-top: 35px;
    min-height: calc(100vh - 64px);
  }
`
const CardWrapper = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-template-rows: repeat(2, 1fr);
  gap: 25px;

  ${Responsive.tablet} {
    grid-template-columns: repeat(2, 1fr);
    gap: 25px;
  }
  ${Responsive.mobile} {
    grid-template-columns: repeat(1, 1fr);
    gap: 20px;
  }
`
const InfoBlock = styled.div``
const InfoTittle = styled.div`
  font-size: 36px;
  color: ${Colors.primaryBlack};
  text-align: center;
  text-transform: capitalize;
  margin-bottom: 60px;
  ${Responsive.mobile} {
    font-size: 18px;
    margin-bottom: 40px;
  }
`

export default Category
